export default {
  route: {
    index: '首页',
    costAnalysis: '成本分析',
    total: '总表',
    india: '印度',
    indiaYearOnYear: '印度同比分析',
    indiaBusinessAnalysis: '印度业务分析',
    warehousing: '仓储费用明细'
  },
  navbar: {
    logOut: '退出登录',
    index: '首页'
  },
  login: {
    title: '系统登录',
    logIn: '登录',
    username: '账号',
    password: '密码',
    any: '随便填',
    thirdparty: '第三方登录',
    thirdpartyTips: '本地不能模拟，请结合自己业务进行模拟！！！'
  },
  errorLog: {
    tips: '请点击右上角bug小图标',
    description: '现在的管理后台基本都是spa的形式了，它增强了用户体验，但同时也会增加页面出问题的可能性，可能一个小小的疏忽就导致整个页面的死锁。好在 Vue 官网提供了一个方法来捕获处理异常，你可以在其中进行错误处理或者异常上报。',
    documentation: '文档介绍'
  },
  button: {
    downloadExcel: '导出Excel'
  },
  tableQuaryMonth: {
    january: '1月',
    february: '2月',
    march: '3月',
    Q1: '第一季度',
    april: '4月',
    may: '5月',
    june: '6月',
    Q2: '第二季度',
    july: '7月',
    august: '8月',
    September: '9月',
    Q3: '第三季度',
    October: '10月',
    november: '11月',
    december: '12月',
    Q4: '第四季度'
  },
  tableMonth: {
    january: '1月',
    february: '2月',
    march: '3月',
    april: '4月',
    may: '5月',
    june: '6月',
    july: '7月',
    august: '8月',
    September: '9月',
    October: '10月',
    november: '11月',
    december: '12月'
  }
}
